import DeselectedSurveysViewModel from "../Calculation/DeselectedSurveysViewModel";

export default class ExportViewModel {
    reportTitle: string = '';
    exportType: string = 'pdf';

    selectionParameters: boolean = true;
    regionsAndAreas: boolean = true;
    mainParameters: boolean = true;
    secondaryFiltering: boolean = true;

    includedSiteList: boolean = true;
    siteDetails: boolean = true;
    surveyDates: boolean = true;

    tripRateGraph: boolean = false;
    arrivals: boolean = false;
    departures: boolean = false;
    totals: boolean = false;
    addUserComments: boolean = false;
    explanatoryCommentsIncluded: boolean = true;
    userComments: string = '';
    displayPDF: boolean = false;
    writePDF: boolean = false;
    fileName: string = '';

    includeFilteringSummary: boolean = false;
    includeEnhancedSiteList: boolean = false;
    keyPeriod: boolean = false;
    userDefinedPeriod: boolean = false;
    userDefinedPeriodStart: number | null = null;
    userDefinedPeriodEnd: number | null = null;
    csvDataToCopy: string = 'tripRateOnly'

    totalVehicles: boolean = false;
    ogvs: boolean = false;
    psvs: boolean = false;
    cyclists: boolean = false;
    vehicleOccupants: boolean = false;
    pedestrians: boolean = false;
    publicTransportUsers: boolean = false;
    busTramPassengers: boolean = false;
    coachPassengers: boolean = false;
    totalRailPassengers: boolean = false;
    taxis: boolean = false;
    cars: boolean = false;
    lgvs: boolean = false;
    motorcycles: boolean = false;
    deselectedSurveys: DeselectedSurveysViewModel[] = [];

    undergroundPassengers: boolean = false;
    dlrPassengers: boolean = false;
    overgroundPassengers: boolean = false;
    nationalRailPassengers: boolean = false;
    tramPassengers: boolean = false;
    waterServicePassengers: boolean = false;
    servicingVehicles: boolean = false;
    busPassengers: boolean = false;
    scooters: boolean = false;
    totalPeople: boolean = false;


    auditors: boolean = true;
    auditCode: string = '';



}
